import Earth from "../image/planeta_zemlia_kosmos_167499_2560x1600 1.png";
import Arrow from "../image/Arrow 1.png";
import asteroid from "../image/pngegg 1.png";
import hazardat from "../image/⚠ Опасен.png";
const Image = {
  earth: `${Earth}`,
  arrow: `${Arrow}`,
  asteroid: `${asteroid}`,
  hazardat: `${hazardat}`,
};
export default Image;
